import React from 'react';
import SettingsOutlinedIcon from '@mui/icons-material/SettingsOutlined';
import StarIcon from '@mui/icons-material/Star';
import StarBorderIcon from '@mui/icons-material/StarBorder';
import { activeSuggestions, bucketConfigUrl } from '../constants';

// A bucket tile in the Publisher Buckets accordion.
//
// Spec 2.2 removes the orange/green status lines and every total/completed/
// published count. Spec 2.3 leaves exactly one number: active suggestions.
// Spec 2.6 requires the COMPLETE bucket name — it wraps rather than truncating.
export default function SectionTile({ bucket, onOpen, isFavourite, onToggleFavourite }) {
  const count = activeSuggestions(bucket);

  return (
    <div className="pbnew-tile" data-bucket-id={bucket._id} onClick={() => onOpen(bucket)} title={`Open ${bucket.name}`}>
      <div className="pbnew-tile-top">
        <div className="pbnew-tile-name">{bucket.name}</div>
        {/* §2.2 — bucket-level favourite. e.stopPropagation so it does not open. */}
        <button
          type="button"
          className={`pbnew-tile-star ${isFavourite ? 'on' : ''}`}
          onClick={(e) => { e.stopPropagation(); onToggleFavourite?.(bucket._id); }}
          title={isFavourite ? 'Remove bucket favourite' : 'Favourite this bucket'}
          aria-label={isFavourite ? 'Remove bucket favourite' : 'Favourite this bucket'}
        >
          {isFavourite ? <StarIcon style={{ fontSize: 15 }} /> : <StarBorderIcon style={{ fontSize: 15 }} />}
        </button>
        <div className="pbnew-tile-count">{count}</div>
      </div>
      <div className="pbnew-tile-foot">
        <span className="pbnew-tile-sub">
          {count === 1 ? '1 active suggestion' : `${count} active suggestions`}
        </span>
        {/* Spec 2.5 — opens this exact bucket's admin configuration in a new tab. */}
        <a
          className="pbnew-tile-configure"
          href={bucketConfigUrl(bucket._id)}
          target="_blank"
          rel="noopener noreferrer"
          onClick={(e) => e.stopPropagation()}
          title="Configure this bucket"
        >
          <SettingsOutlinedIcon style={{ fontSize: 14 }} /> Configure
        </a>
      </div>
    </div>
  );
}
